<div class="row mt-3">
  <div class="col d-flex">
    <div class="everlabel">
      <span>Prior Study Date *</span>
    </div>
    <div class="ml-3 everlabel">
      <span>Modality *</span>
    </div>
    <div class="ml-3 everlabel">
      <span>Accession Number</span>
    </div>
  </div>
</div>
<div
  class="row"
  *ngFor="let priorForm of priorForms.controls; let rowIndex = index"
  [formGroup]="priorForm"
>
  <div class="col d-flex">
    <div>
      <mat-form-field
        class="editor"
        [hideRequiredMarker]="true"
        floatLabel="auto"
      >
        <input
          matInput
          [matDatepicker]="priorDatePicker"
          [matDatepickerFilter]="dateFilter"
          placeholder="dd/mm/yyyy"
          formControlName="priorDate"
          id="priorDate"
          [readonly]="!this.priorSent"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="priorDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #priorDatePicker></mat-datepicker>
        <mat-error
          *ngIf="
            priorForm.controls.priorDate.invalid &&
            (priorForm.controls.priorDate.dirty ||
              priorForm.controls.priorDate.touched)
          "
          class="invalid-feedback"
        >
          <div
            *ngIf="
              priorForm.controls.priorDate.errors.required &&
              !priorForm.controls.priorDate.errors.matDatepickerParse
            "
          >
            Prior Study Date is required.
          </div>
          <div *ngIf="priorForm.controls.priorDate.errors.matDatepickerFilter">
            Future date is not allowed.
          </div>
          <div *ngIf="priorForm.controls.priorDate.errors.matDatepickerParse">
            Invalid date format
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-3">
      <mat-form-field class="editor" [hideRequiredMarker]="true">
        <mat-label>Select Modality</mat-label>
        <mat-select formControlName="modality" id="priorModality">
          <mat-option *ngFor="let m of modalityList" value="{{ m }}">
            {{ m }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="
            priorForm.controls.modality.invalid &&
            (priorForm.controls.modality.dirty ||
              priorForm.controls.modality.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="priorForm.controls.modality.errors.required">
            Please select a Modality.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-3">
      <mat-form-field class="editor">
        <input
          type="text"
          matInput
          formControlName="accessionNumber"
          id="priorAccessionNumber"
          [readonly]="!this.priorSent"
        />
        <mat-error
          *ngIf="
            priorForm.controls.accessionNumber.invalid &&
            (priorForm.controls.accessionNumber.dirty ||
              priorForm.controls.accessionNumber.touched)
          "
          class="invalid-feedback"
        >
          <div *ngIf="priorForm.controls.accessionNumber.errors.maxlength">
            Accession Number must be no more than 50 characters long.
          </div>
          <div *ngIf="priorForm.controls.accessionNumber.errors.pattern">
            Invalid characters in the field.
          </div>
        </mat-error>
      </mat-form-field>
    </div>
    <div class="ml-4">
      <button
        type="button"
        *ngIf="priorForms.length > 1"
        (click)="deletePriorInternal(rowIndex)"
        id="deletePrior"
        mat-icon-button
      >
        <mat-icon class="mat-evericon">delete_outline</mat-icon>
      </button>
      <button
        type="button"
        *ngIf="rowIndex === priorForms.length - 1"
        (click)="addPriorInternal()"
        [disabled]="!this.priorSent"
        id="addPrior"
        class="ml-2"
        mat-icon-button
      >
        <mat-icon class="mat-evericon">add</mat-icon>
      </button>
    </div>
  </div>
</div>
